import { createAction } from 'redux-actions';

import { FETCH_ALLEYE_PROVIDERS, RESET_ALLEYE_PROVIDERS, LOADING_ALLEYE_PROVIDERS } from './consts';

export const fetchAlleyeProviders = createAction(FETCH_ALLEYE_PROVIDERS);
export const resetAlleyeProviders = createAction(RESET_ALLEYE_PROVIDERS);
export const setIsLoadingTrue = createAction(LOADING_ALLEYE_PROVIDERS);
